import zh from '../../resources/locales/zh-CN.json';
import warehouse from './zh-CN/warehouse';
import aes from './zh-CN/aes';
import afr from './zh-CN/afr';
import mailbox from './zh-CN/mailbox';
export default {
  ...zh,
  ...warehouse,
  ...aes,
  ...afr,
  ...mailbox,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['zh-CN'],
};
